import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';

import Icon from '@ontruck/ontruck-react-components/lib/Icon';
import { Loading } from 'components/Loading';

import style from './style.module.scss';

class ImageItem extends Component {
  render() {
    const { file, loading } = this.props;

    const className = {
      item: classnames(style.imageItem, {
        [style.imageItemLoading]: loading,
      }),
    };

    const onDeleteClick = (file) => {
      if (this.props.onDelete) {
        this.props.onDelete(file);
      }
    };

    return loading ? (
      <div className={className.item}>
        <Loading className={style.itemLoading} />
      </div>
    ) : (
      <div className={className.item}>
        <span className={style.deleteButton} onClick={() => onDeleteClick(file)}>
          <Icon name="close" className={style.deleteIcon} />
        </span>
        <img alt="" src={file.preview} />
      </div>
    );
  }
}

ImageItem.propTypes = {
  file: PropTypes.any,
  loading: PropTypes.bool,
  onDelete: PropTypes.func,
};

export default ImageItem;
